import {drag} from 'd3-drag'
import {scaleLinear} from 'd3-scale'

const HANDLE_FILL = '#FBE499'
const HANDLE_STROKE = '#A67400'
const RADIUS = 4.5

/*
 * Returns the cursor to use for the given angle and default cursor.
 */
function getCursor (angle, cursor) {
  // If the angle is between 45 and 135 degrees, or 225 and 315 degrees
  if (angle >= 45 && angle < 135 || angle >= 225 && angle < 315) {
    // if the cursor is the vertical resize cursor, use the horizontal resize cursor
    if (cursor === 'ns-resize') {
      cursor = 'ew-resize'
    } else if (cursor === 'ew-resize') {
      // Use the vertical resize cursor
      cursor = 'ns-resize'
    }
  }

  return cursor
}

function setStyles (selection) {
  return selection.style('fill', d => d.fill)
    .style('stroke', d => d.stroke)
    .style('pointer-events', d => d['pointer-events'])
    .style('stroke-width', '1px')
    .style('cursor', d => d.cursor)
    .attr('cx', d => d.cx)
    .attr('cy', d => d.cy)
    .attr('r', d => d.r)
}

export default function (selection, symbol, transition) {
  const duration = transition ? 1000 : 0 // Matches the path transition duration

  // Remove any handles that don't match the current symbol type
  selection.selectAll(`circle.symbol-control-handle:not(.${symbol.type})`)
    .remove() // Remove them immediately

  return selection.selectAll(`circle.symbol-control-handle.${symbol.type}`)
    .data(d => {
      // We can't clamp these scale functions b/c some symbols may have negative x/y offsets
      const xScale = scaleLinear().range([0, d.dimensions.width])
      const yScale = scaleLinear().range([0, d.dimensions.height])

      return [].concat(...d.handles.map(handle => {
        const cx = xScale(handle.coords[0])
        const cy = yScale(handle.coords[1])

        const circle = {
          r: RADIUS,
          cx,
          cy,
          fill: HANDLE_FILL,
          stroke: HANDLE_STROKE,
          'pointer-events': 'none',
          handle,
          type: symbol.type,
          allHandles: d.handles,
          dimensions: d.dimensions,
        }
        // The first circle returned is the larger hit area, and the second is the actual handle.
        return [Object.assign({}, circle, {
          r: RADIUS * 2.5,
          fill: 'transparent',
          'pointer-events': 'visible',
          cursor: getCursor(d.dimensions.angle, handle.cursor),
          stroke: 'none',
        }), circle]
      }))
    })
    .join(enter => {
      return enter.append('circle')
        .attr('class', d => `symbol-control-handle ${d.type}`)
        .style('opacity', 0)
        .call(setStyles)
        .call(drag()
          .on('start', (e, d) => {
            symbol.emit('handle:dragstart', d)
          })
          .on('drag', (e, d) => {
            const coords = d.handle.coords.slice()

            symbol.enforceConstraints(d.handle, d.dimensions, d.allHandles, [e.x / d.dimensions.width, e.y / d.dimensions.height])

            const diff = [
              d.handle.coords[0] - coords[0],
              d.handle.coords[1] - coords[1]
            ]
            if (diff[0] !== 0 || diff[1] !== 0) {
              symbol.onHandleChange?.(d.handle, diff, d.allHandles, d.dimensions)
              symbol.emit('handle:drag', d.handle.idx, d.handle.coords)
            }
          })
          .on('end', (e, d) => {
            symbol.emit('handle:dragend')
          })
        )
        .transition()
        .delay(duration) // Wait until the path transition is done, then fade in quickly
        .style('opacity', 1)
    }, update => {
      return update.call(setStyles)
    }, exit => {
      return exit.remove()
    })

}
